/**
 * Performs a conditional match check against the form field with the given test value.
 * This functionality is considered identical to that in Atlas::Extensions::Dato::Matcher.match?
 *
 * @param {string} fieldValue - The form field value
 * @param {string} testValue - The value of our conditional test
 * @returns {boolean} True if the match succeeded
 */
 export default function match(fieldValue, testValue) {
  if(typeof(testValue) === 'object') {
    return Object.entries(testValue).every(([type, value]) => (
      matchAdvanced(fieldValue, type, value)
    ));
  } else {
    return matchString(fieldValue, testValue);
  }
}

function matchString(fieldValue, testValue) {
  // if test value is blank, test presence
  if(!testValue || !fieldValue) { return !!fieldValue; }

  // comma-split the field value to check any value
  return String(fieldValue).toLowerCase().split(/,\s*/).some(value => {
    // if test value matches /regex/, test as regex
    if(testValue.match(/^\/.+\/$/)) { return matchRegexp(value, testValue); }

    // test as comma-split string
    return testValue.toLowerCase().split(/,\s*/).includes(value);
  });

}

function matchRegexp(fieldValue, testValue) {
  try {
    return (new RegExp(testValue.match(/^\/(.+)\/$/)[1], 'i')).test(fieldValue);
  } catch {
    return false;
  }
}

/**
 * Performs a conditional match check against the form field with the given test.
 * The type is expected to be one or more advanced check types.
 * Supported conditions are eq, neq, in, nin, contain, ncontain, presence, blank, regex.
 * 
 * @param {string} fieldValue 
 * @param {string} type 
 * @param {string} testValue 
 * @returns {boolean}
 */
function matchAdvanced(fieldValue, type, testValue) {
  const lowerFieldValue = fieldValue ? String(fieldValue).toLowerCase() : '';
  const lowerTestValue = testValue ? String(testValue).toLowerCase() : '';

  if(type[0] === 'n') {
    return !matchAdvancedInternal(lowerFieldValue, type.slice(1), lowerTestValue);
  }

  return matchAdvancedInternal(lowerFieldValue, type, lowerTestValue);
}

function matchAdvancedInternal(fieldValue, type, testValue) {
  try {
    switch(type) {
      case 'contains': return fieldValue.includes(testValue);
      case 'eq': return fieldValue === testValue;
      case 'in': return testValue.split(/,\s*/).includes(fieldValue);
      case 'presence': return fieldValue;
      case 'blank': return !fieldValue;
      case 'regex': return (new RegExp(testValue)).test(fieldValue);
      default: return true;
    }
  } catch {
    return false;
  }
}
